import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  Flex,
  Spacer,
} from "@chakra-ui/react";
import { LinkButton } from "../shared/generic";
import { ChevronRightIcon } from "@chakra-ui/icons";

export const ModalFreeUnlockIneligible = ({ open, onClose }) => (
  <Modal onClose={onClose} isOpen={open}>
    <ModalOverlay />
    <ModalContent>
      <ModalHeader p={8} fontSize="3xl" fontFamily="heading" textAlign="center">
        Sorry! This profile is not eligible for a free unlock.
      </ModalHeader>
      <ModalBody fontSize="xl">
        <Text>
          To protect the integrity of our database, we only allow free unlocks on certain profiles
          that meet our criteria. You find these profiles by searching with the filter
          &quot;Eligible for Free Unlock&quot;.
        </Text>
      </ModalBody>
      <ModalFooter>
        <Flex>
          <Spacer />
          <LinkButton colorScheme="green" href="/profiles?advanced=true&eligible_for_free=true">
            Search for eligible profiles
          </LinkButton>
        </Flex>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export const ModalFreeUnlockProfile = ({ open, onClose }) => {
  return (
    <Modal onClose={onClose} isOpen={open}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader p={8} fontSize="3xl" fontFamily="heading" textAlign="center">
          Unlock this profile for free!
        </ModalHeader>
        <ModalBody fontSize="xl">
          <Text>
            Get full access to this student&apos;s personal statements, supplemental essays,
            activities, awards, advice, &amp; additional information.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Flex>
            <Spacer />
            <LinkButton
              colorScheme="green"
              size="lg"
              href="/plans"
              mt={4}
              rightIcon={<ChevronRightIcon />}
            >
              Claim my free unlock
            </LinkButton>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default function ModalFreeUnlockEligible({ isOpen, onClose }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Congrats! You&apos;re eligible for a free profile unlock!</ModalHeader>
        <ModalBody>
          <Text fontSize="lg">
            🥳 This gift&apos;s on us. You can use this to unlock any profile you want on the first
            page of search results. Just click a profile you&apos;d like, and you&apos;ll be able to
            read their entire college applications, for free!
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="gray" mr={3} onClick={onClose}>
            No Thanks
          </Button>
          <LinkButton href="/plans?claimFreeUnlock=true" colorScheme="green">
            Claim!
          </LinkButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
